import * as chatActions from "../reducers/chat";

class ChatClient {
    constructor(store) {
        this._store = store;
    }

    setStore(store) {
        this._store = store;
    }

    createMiddleware() {
        return ({ dispatch, getState }) => (next) => (action) => {
            let res = next(action);
            switch (action.type) {
                case 'chat/addMessage': {
                    const data = action.payload;

                    let message = data.message.content;
                    if (message) {
                        try {
                            message = message.replace(/[0-9@#!$%^&*(){}|":<>?/.,';=-=+_]/g, '');
                            let emoji = message.match(/[\p{Emoji}\u200d]+/gu);
                            if (emoji && emoji.length) {
                                emoji = emoji.join('');

                                if(this.emojiTimeout) {
                                    clearTimeout(this.emojiTimeout);
                                }
                                dispatch(chatActions.hideEmojiForm());
                                dispatch(chatActions.showEmojiForm({emoji: emoji}));
                            }
                        } catch (e) {
                            console.error(e);
                        }
                    }

                    break;
                }
                case 'chat/showEmojiForm': {
                    this.emojiTimeout = setTimeout(() => {
                        dispatch(chatActions.hideEmojiForm());
                    }, 5000);
                    break;
                }
            }
            return res;
        };
    }
}

export default new ChatClient();